<div class="row user-header">
  <div class="col-auto">
    <div class="user-image">
      <img *ngIf="isUserLoggedIn" [src]="userProfileModel.imageUrl ? userProfileModel.imageUrl : './assets/img/common/no-photo.png'" (click)="goToProfileDetail()">
      <img *ngIf="!isUserLoggedIn" src="/assets/img/common/no-photo.png" (click)="login()">
    </div>
  </div>
  <div class="col d-flex align-items-center p-0">
    <p *ngIf="isUserLoggedIn" class="user-info" (click)="goToProfileDetail()">
      {{ userProfileModel.name | usernameFormat }} <br>
      {{ userProfileModel.phone_no | thai2d3dPhone4 }}
    </p>
    <p *ngIf="!isUserLoggedIn" class="user-info" (click)="login()">{{ 'click_to_login' | translate }}</p>
  </div>
  <div class="col-auto pt-2" *ngIf="routerName == '/home' || routerName == '/game/list/'+providerId">
    <app-language-picker></app-language-picker>
  </div>
</div>

<div class="row user-balance-card mx-0" *ngIf="parentLink != '/profile' && isUserLoggedIn">
  <div class="col pr-0">
    <span>{{ 'balance' | translate }} ({{ 'ks' | translate }})</span>
    <img (click)="toggleAmount(!showAmount)" [src]="showAmount ? 'assets/img/common/eye-icon.png' : 'assets/img/common/eye-off-icon.png'" alt="" class="st-icon">
    <h3 *ngIf="!loadingBalance">{{ showAmount ? (showBalance | number : '1.2-2') : "*****" }}</h3>
    <ngx-spinner *ngIf="loadingBalance" [name]="common.loading.balanceLoading.name"
      [size]="common.loading.balanceLoading.size" [color]="common.loading.balanceLoading.color"
      [type]="common.loading.balanceLoading.type" [fullScreen]="common.loading.balanceLoading.fullScreen"
      [bdColor]="common.loading.balanceLoading.bdColor"></ngx-spinner>
  </div>
  <div class="col-auto d-flex align-items-center pl-0">
    <button *ngIf="parentLink == '/home'" class="btn top-up-btn" (click)="goToTopup()">
      <img src="./assets/img/wallet/wallet_topup.png">
      <span>{{ 'top_up' | translate }}</span>
    </button>
    <button *ngIf="parentLink == '/wallet'" class="btn history-btn" (click)="goToHistory()">
      <img src="assets/img/common/bet-history-white.png" alt="">{{ 'history' | translate }}
    </button>
    <button *ngIf="parentLink == '/game-list'" class="btn transfer-btn" (click)="selectGameListId()">
      <img src="assets/img/wallet/game_wallet.png" alt="" width="40" height="auto"> {{ 'game_balance_transfer' | translate }}
    </button>
  </div>
</div>